import script from "./ReasoningModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReasoningModal.vue?vue&type=script&setup=true&lang=js"

import "./ReasoningModal.vue?vue&type=style&index=0&id=37895882&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37895882"]])

export default __exports__